import { Autocomplete, Box, InputAdornment, OutlinedInput, TextField } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import endpoints from '../constants/endpoints';
import useFetch from '../hooks/useFetch';
import useApiRequest from '../services/apiRequest';
import { GlobalStateContext } from '../wrappers/GlobalContext';
import AssistedSearch from './AssistedSearch';
import { AccountCircle, Add } from '@mui/icons-material';

function SearchInputOverprice() {
    const { queryStringConverter } = useApiRequest();
    const { typedDescriptionOverprice, setTypedDescriptionOverprice } = useContext(GlobalStateContext);
    const { searchType, setSearchType } = useContext(GlobalStateContext);
    const { typedSearchType, setTypedSearchType } = useContext(GlobalStateContext);
    const { searchTermOverprice, setSearchTermOverprice } = useContext(GlobalStateContext);

    const { data, error, loading } = useFetch(endpoints.AUTOCOMPLETE_OVERPRICE, queryStringConverter({ desc: typedDescriptionOverprice || " " }));

    const [open, setOpen] = useState(false);

    const options = () => {
        return data ? data.map((d: any) => d.desc) : [];
    }

    useEffect(() => {
        if (typedDescriptionOverprice === "") {
            setOpen(true);
        }
    }, [typedSearchType]);

    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            setTypedDescriptionOverprice(searchTermOverprice);
        }, 1500);

        return () => clearTimeout(delayDebounceFn);
    }, [searchTermOverprice]);

    const onInputChange = (value: string) => {
        setSearchTermOverprice(value);
    };

    return (
        typedSearchType === "smart" ? (
            <Autocomplete
                options={options()}
                onInputChange={(event, newInputValue) => {
                    console.log(newInputValue);
                    onInputChange(newInputValue);  // Chama a função aqui
                }}
                value={searchTermOverprice}
                loading={loading}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        onChange={(ev) => {
                            const value = ev.target.value;
                            setSearchTermOverprice(value);
                            onInputChange(value);  // Chama a função aqui também
                        }}
                        label="Digite uma descrição"
                        InputProps={{
                            ...params.InputProps,
                            type: 'text',
                        }}
                    />
                )}
            />
        ) : (
            <>
                <AssistedSearch open={open} onClose={() => setOpen(false)} />
                <Box sx={{
                    boxShadow: 3,
                    "&:hover": {
                        boxShadow: 8,
                    },
                }}>
                    <OutlinedInput
                        value={typedDescriptionOverprice}
                        placeholder='Clique para adicionar'
                        endAdornment={<InputAdornment position="end"><Add /></InputAdornment>}
                        sx={{ cursor: 'pointer' }}
                        fullWidth
                        onClick={() => setOpen(true)}
                    />
                </Box>
            </>
        )
    );
}

export default SearchInputOverprice;
